<template>
  <a-table class="table" :columns="columns" :dataSource="data" :pagination="false" bordered> </a-table>
</template>
<script>
export default {
  data () {
    return {
      columns: [
        {
          title: '会计年度',
          dataIndex: 'anln1',
          align: 'center',
          width: 100
        },
        {
          title: 'APC业务',
          dataIndex: 'afabe',
          align: 'center',
          width: 100
        },
        {
          title: '购置价值',
          dataIndex: 'afasl',
          align: 'center',
          width: 100
        },
        {
          title: '正常折旧',
          dataIndex: 'ndjar',
          align: 'center',
          width: 100
        },
        {
          title: '账面净值',
          dataIndex: 'ndper',
          align: 'center',
          width: 100
        },
        {
          title: '货币',
          dataIndex: 'currency',
          align: 'center',
          width: 100
        },
      ],
      data: [
        {
          id: '1',
          anln1: '2021',
          afabe: '389,858.48',
          afasl: '389,858.48',
          ndjar: '84,469.34-',
          ndper: '305,389.14',
          currency: 'CNY'
        },
        {
          id: '2',
          anln1: '2021',
          afabe: '',
          afasl: '389,858.48',
          ndjar: '84,469.34-',
          ndper: '305,389.14',
          currency: 'CNY'
        },
        {
          id: '3',
          anln1: '2021',
          afabe: '',
          afasl: '389,858.48',
          ndjar: '84,469.34-',
          ndper: '305,389.14',
          currency: 'CNY'
        },
        {
          id: '4',
          anln1: '2021',
          afabe: '',
          afasl: '389,858.48',
          ndjar: '84,469.34-',
          ndper: '305,389.14',
          currency: 'CNY'
        },
        {
          id: '5',
          anln1: '2021',
          afabe: '',
          afasl: '389,858.48',
          ndjar: '84,469.34-',
          ndper: '305,389.14',
          currency: 'CNY'
        }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.table /deep/ .ant-table-thead > tr > th {
  padding: 10px !important;
}
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px !important;
}
</style>
